// extracted by mini-css-extract-plugin
export var container = "index-module--container--z10W8";
export var ghostClass = "index-module--ghostClass--3DAvP";